import { registerMutation } from '@adornis/baseql/metadata/register.js';
import { getCollection } from '@adornis/baseql/server/collections.js';
import { loadAndAssert } from '../authz/access.js';
import { Exam } from '../exam.js';
import { persistGrammarFiOutcomes } from './persist-grammar-fi-outcomes.js';

export const updateGrammarFiSettingsMutation = registerMutation({
  operationName: 'updateGrammarFiSettingsMutation',
  type: () => Boolean,
  params: [
    { name: 'examId', type: () => String },
    { name: 'grammarFiSettingsJson', type: () => String },
  ],
  resolve: (examId: string, grammarFiSettingsJson: string) => async () => {
    // Validate that it's valid JSON with the expected shape (see shared/grammar-grading.ts)
    const parsed = JSON.parse(grammarFiSettingsJson);
    if (typeof parsed?.fiEnabled !== 'boolean' || !Array.isArray(parsed?.thresholds)) {
      throw new Error('Ungültiges Fehlerindex-Format.');
    }
    if (parsed.alwaysUseFi !== undefined && parsed.alwaysUseFi !== null && typeof parsed.alwaysUseFi !== 'boolean') {
      throw new Error('Ungültiges Fehlerindex-Format.');
    }

    await loadAndAssert(Exam, examId, 'update', { _id: 1 });
    const examCollection = await getCollection(Exam);
    const result = await examCollection.updateOne({ _id: examId }, { $set: { grammarFiSettingsJson } });

    if (result.matchedCount === 0) {
      throw new Error(`Klausur mit ID ${examId} nicht gefunden.`);
    }

    // Recompute the persisted per-student FI outcomes with the new settings (fire-and-forget).
    void persistGrammarFiOutcomes(examId);

    return true;
  },
});
